import { Info } from '@mafc/icon';
import COLORS from 'theme/colors';
import * as S from './InfoContainer.style';

const InfoContainer: React.FC<{
  children: React.ReactNode;
  style?: Record<string, string>;
}> = ({ children, style = {} }) => {
  return (
    <S.InfoContainer style={style}>
      <S.InfoIconWrapper as="span">
        <Info height="18px" width="18px" strokeWidth="2" fill={COLORS.BLUE_600} />
      </S.InfoIconWrapper>
      {children}
    </S.InfoContainer>
  );
};

export default InfoContainer;
